(() => {
  const DEFAULT_FREE_SHIPPING_THRESHOLD = 115;

  const SELECTORS = {
    drawer: "cart-drawer",
    subtotal: ".cart-drawer__footer .totals__total-value",
    bar: "[data-free-shipping-threshold]",
    message: "[data-free-shipping-message]",
    progress: "[data-free-shipping-progress]",
  };

  let subtotalObserver = null;

  function parseMoney(text) {
    if (!text) return null;
    const cleaned = text.replace(/\s+/g, "").replace(/[^\d.,]/g, "");
    if (!cleaned) return null;
    // If both comma and dot exist, comma is a thousands separator → remove it
    // If only comma exists, treat it as decimal separator → replace with dot
    if (cleaned.includes(",") && cleaned.includes(".")) {
      return parseFloat(cleaned.replace(/,/g, ""));
    }
    return parseFloat(cleaned.replace(",", "."));
  }

  function getThreshold() {
    const barEl = document.querySelector(SELECTORS.bar);
    const value = barEl ? parseFloat(barEl.dataset.freeShippingThreshold) : NaN;
    return Number.isFinite(value) && value > 0
      ? value
      : DEFAULT_FREE_SHIPPING_THRESHOLD;
  }

  function getSubtotal() {
    const el = document.querySelector(SELECTORS.subtotal);
    return el ? parseMoney(el.textContent) : null;
  }

  function updateBar() {
    const messageEl = document.querySelector(SELECTORS.message);
    const progressEl = document.querySelector(SELECTORS.progress);
    if (!messageEl || !progressEl) return;

    const subtotal = getSubtotal();

    // Marking the node instead of a module variable keeps this in sync with a
    // re-rendered drawer, and stops the drawer observer from looping on the
    // text we write here.
    const applied = String(subtotal);
    if (messageEl.dataset.freeShippingApplied === applied) return;
    messageEl.dataset.freeShippingApplied = applied;

    const threshold = getThreshold();

    if (!subtotal || subtotal <= 0) {
      messageEl.textContent = `Free Delivery on orders £${threshold}+`;
      progressEl.style.width = "0%";
      return;
    }

    const remaining = Math.max(threshold - subtotal, 0);
    const progress = Math.min(Math.max((subtotal / threshold) * 100, 0), 100);

    messageEl.textContent =
      remaining === 0
        ? "You’ve unlocked free shipping!"
        : `You’re £${remaining.toFixed(2)} away from free shipping.`;

    progressEl.style.width = `${progress}%`;
  }

  function observeSubtotal() {
    if (subtotalObserver) subtotalObserver.disconnect();

    const subtotalEl = document.querySelector(SELECTORS.subtotal);
    if (!subtotalEl) return;

    subtotalObserver = new MutationObserver(updateBar);
    subtotalObserver.observe(subtotalEl, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    updateBar();
  }

  function init() {
    const drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;

    new MutationObserver(() => {
      observeSubtotal();
    }).observe(drawer, {
      childList: true,
      subtree: true,
    });

    // A cart that is already filled on page load never mutates the drawer, so
    // the first paint has to be requested explicitly.
    observeSubtotal();
  }

  document.addEventListener("DOMContentLoaded", init);
})();
